export class PaginationFeaturesDto {
    page: number;           // Página actual
    sizePage: number;       // Cantidad de elementos por página
    orderField: string;     // Campo a ordenar
    order: number;          // Orden: 1 para ascendente, 0 para descendente

    constructor(data: Partial<PaginationFeaturesDto>) {
        this.page = data.page || 1;
        this.sizePage = data.sizePage || 15;
        this.orderField = data.orderField || '';
        this.order = data.order || 1;
    }
}